import { ColorsNeutral400, ColorsPrimary500 } from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const wrapper = css({
  '&.MuiBox-root': {
    marginTop: '1rem',
  },
});

const actionElement = css({
  display: 'flex',
  alignItems: 'flex-start',
  color: ColorsNeutral400,
  marginBottom: '5px',
  gap: 5,
});

const clearIcon = css({
  '&.MuiSvgIcon-root': {
    color: ColorsNeutral400,
    width: '16px',
    height: '16px',
  },
});

const checkIcon = css({
  '&.MuiSvgIcon-root': {
    color: ColorsPrimary500,
    width: '16px',
    height: '16px',
  },
});

const UserActionsStyles = {
  wrapper,
  actionElement,
  clearIcon,
  checkIcon,
};

export default UserActionsStyles;
